// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { FC } from "react";
import { useSelector } from "react-redux";

/* Store Custom Code */
import useGetCurrentProduct from "@store/Framework/Store/Data/Products/ProductsHooks/useGetCurrentProduct";
import { shallowEqual } from "react-redux";

const SignInToSeePriceButton: FC<ButtonPresentationProps> = ({ ...buttonProps }) => {
    const history = useHistory();
    const state = useSelector((state: ApplicationState) => {
        return {
            currentLocation: getLocation(state),
            signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        };
    }, shallowEqual);
    /* Store Custom Code */
    const productDetailPath = useGetCurrentProduct()?.productInfo?.productDetailPath;
    const signInHandler = () => {
        if (!state.signInUrl) {
            logger.warn("No url was found for SignInPage, defaulting to /SignIn");
            history.push("/MyAccount/SignIn");
        } else {
            /* Store Custom Code */
            const returnUrl = productDetailPath ?? state.currentLocation.pathname + state.currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${state.signInUrl}`);
            } else {
                history.push(`${state.signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
            }
        }
    };

    return (
        <Button {...buttonProps} onClick={signInHandler}>
            {translate("Sign in to see price")}
        </Button>
    );
};

export default SignInToSeePriceButton;
